/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ContractsState} from "./contracts.reducer";

// Selector functions
const contractsData =
  createFeatureSelector<ContractsState>('ss-cord.contracts');

// Dummy
export const contractDetailsInfo = createSelector(
  contractsData,
  (state: ContractsState) => state.contractDetailsInfo
);
